import { gql, useQuery } from "@apollo/client";

const FEATURE_FLAGS = gql`
  query FeatureFlags {
    featureFlags {
      newHome
      companyHierarchy
    }
  }
`;

export interface FeatureFlags {
  newHome: boolean;
  companyHierarchy: boolean;
}

const DEFAULT_FLAGS: FeatureFlags = {
  newHome: false,
  companyHierarchy: false,
};

export const useFeatureFlags = () => {
  const { data, loading } = useQuery<{ featureFlags: FeatureFlags }>(
    FEATURE_FLAGS,
  );
  return { flags: data?.featureFlags ?? DEFAULT_FLAGS, loading };
};
